import { FieldsEnum, FormsEnum, PersonType } from 'app/shared/enums';
import { validateIsUniquePesel } from 'app/validators';
import { getFormValue } from 'app/services/businessFunctionHelpers';
import { validateTravelPeselUniqueness } from 'app/services/businessFunctions/helpers/validateTravelPeselUniqueness';
import {
  calculationOwnersPeselsKeys,
  checkoutOwnersPeselKeys,
  completeDataOwnersPeselsKeys,
} from './peselsKeys';

export function revalidatePeselsUniqueness(formName: FormsEnum): void {
  if (formName === FormsEnum.TravelCheckoutForm) {
    validateTravelPeselUniqueness(FieldsEnum.TravelInsurantPesel);
    return;
  }

  Object.values(PersonType).forEach((o) => {
    let questionKey;

    switch (formName) {
      case FormsEnum.CheckoutForm:
        questionKey = checkoutOwnersPeselKeys.questionField[o] || undefined;
        break;
      case FormsEnum.CalculationForm:
      case FormsEnum.CompareCepikDataForm:
        questionKey = calculationOwnersPeselsKeys.questionField[o] || undefined;
        break;
      case FormsEnum.CompleteDataForm:
        questionKey =
          completeDataOwnersPeselsKeys.questionField[o] || undefined;
        break;
    }

    if (!questionKey) return;

    const value = getFormValue(questionKey, formName);

    if (!!value) {
      validateIsUniquePesel({
        value,
        questionKey,
        formName,
      });
    }
  });
}
